import { useState } from "react"
import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"
import { Search, Bell, MessageSquare, ChevronRight } from "lucide-react"
import { StudentHero } from "../components/ui/school/student-overview/student-hero"
import { GuardianInfoCard } from "../components/ui/school/student-overview/guardian-info-card"
import { FinancialStatusCard } from "../components/ui/school/student-overview/financial-status-card"
import { AchievementsCard } from "../components/ui/school/student-overview/achievements-card"
import { HobbiesCard } from "../components/ui/school/student-overview/hobbies-card"
import { SkillsCard } from "../components/ui/school/student-overview/skills-card"
import { PerformanceTabs } from "../components/ui/school/student-overview/performance-tabs"
import { CareerPathsCard } from "../components/ui/school/student-overview/career-paths-card"

import {
  sampleStudent,
  sampleGuardian,
  sampleFinancial,
  sampleTasks,
  sampleActivityLogs,
  nigerianSubjects,
  enrolledSubjects,
  careerPathsData,
  achievementsData,
} from "../lib/student-overview-data"

const StudentOverviewPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  return (
    <div className="flex h-screen bg-gray-50">
      <SchoolSidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

       <main className="flex-1 lg:ml-64 p-4 md:p-8 overflow-y-auto">
         <header className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Students Overview</h1>
            <p className="text-gray-500 mt-1">View and manage student records</p>
          </div>
          <button className="relative p-3 rounded-full hover:bg-white transition border border-gray-200">
            <Bell className="text-gray-600 w-6 h-6" />
            <span className="absolute top-2 right-2 block h-2 w-2 rounded-full bg-red-500"></span>
          </button>
        </header>

        <div className="flex-1 overflow-y-auto bg-gray-50 p-6 lg:p-8">
          <div className="max-w-6xl mx-auto flex flex-col gap-6">
            <nav className="flex text-sm text-gray-500 font-medium">
              <a className="hover:text-teal-500 transition-colors" href="#">
                Students
              </a>
              <ChevronRight className="w-4 h-4 mx-2 mt-0.5" />
              <a className="hover:text-teal-500 transition-colors" href="#">
                JSS 2
              </a>
              <ChevronRight className="w-4 h-4 mx-2 mt-0.5" />
              <span className="text-gray-900">Chinedu Okafor</span>
            </nav>

            <StudentHero
              name={sampleStudent.name}
              studentId={sampleStudent.studentId}
              class={sampleStudent.class}
              house={sampleStudent.house}
              careerPath={sampleStudent.careerPath}
              status={sampleStudent.status}
              enrolledSubjects={enrolledSubjects}
            />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              <div className="lg:col-span-8 flex flex-col gap-6">
                <CareerPathsCard careerPaths={careerPathsData} />

                <PerformanceTabs
                  subjects={nigerianSubjects}
                  tasks={sampleTasks}
                  activities={sampleActivityLogs}
                  tasksCompleted={45}
                  currentStreak={12}
                  engagementRate={87}
                  attendanceRate={95}
                />
              </div>

              <div className="lg:col-span-4 flex flex-col gap-6">
                <AchievementsCard achievements={achievementsData} />
                {/* <GuardianInfoCard guardian={sampleGuardian} /> */}
                {/* <FinancialStatusCard financial={sampleFinancial} guardianEmail={sampleGuardian.email} /> */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default StudentOverviewPage